import React from "react";

// reactstrap components
import {
    Col,
    Alert,
    Table,
    Badge,
    Button,
    Modal,
    FormGroup,
    Label,
    Input,
    Card,
    CardHeader,
    CardBody,
} from "reactstrap";
import NumberFormat from 'react-number-format';
import { authFetch } from "../../helpers/FetchHelpers";

class UserCreditApprovals extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            toBeApproved: {},
            total_kredit: '',
            submitting: false,
            submittingAction: undefined, // 'approve' or 'reject'
            notificationModal: false,
            errorMessage: undefined,
        }
    }

    toggleModal = (creditApproval) => {
        this.props.toggleModal("notificationModal", "approve", creditApproval)
    }

    toggleModals = (state, creditApproval) => {
        this.setState(prev => ({
            [state]: !prev[state],
            toBeApproved: creditApproval || prev.toBeApproved,
            errorMessage: undefined,
            total_kredit: state === 'notificationModal' && !prev[state] ? prev.total_kredit : '',
        }));
    };

    handleSubmitApproval = async (status) => {
        const { toBeApproved, total_kredit } = this.state;
        if (!total_kredit || Number(total_kredit) <= 0) {
            this.setState({ errorMessage: 'Total kredit harus diisi dan lebih dari 0.' });
            return;
        }
        this.setState({ submitting: true, submittingAction: status, errorMessage: undefined });
        try {
            const endpoint = status === 'reject' ? '/kredit/reject' : '/kredit/approve';
            const res = await authFetch(
                process.env.REACT_APP_API_URL + endpoint,
                'POST',
                JSON.stringify({
                    kredit_id: toBeApproved?.kredit_id,
                    total_kredit: Number(total_kredit),
                })
            );
            const err = res?.data?.errorMessage || res?.data?.header?.error_message;
            if (err) {
                this.setState({ errorMessage: err });
            } else {
                this.props.setSuccessMessage(status === 'reject' ? 'Kredit berhasil ditolak.' : 'Kredit berhasil disetujui.');
                this.props.fetchData();
                this.toggleModals('notificationModal');
                this.setState({ total_kredit: '' });
            }
        } catch (e) {
            this.setState({ errorMessage: 'Terjadi kesalahan jaringan. Coba lagi.' });
        } finally {
            this.setState({ submitting: false, submittingAction: undefined });
        }
    }

    render() {
        const creditApprovals = this.props.creditApprovals?.filter(creditApproval => creditApproval) || [];
        const { toBeApproved, notificationModal, errorMessage } = this.state;

        return (
            <>
                {errorMessage && (
                    <Col xs="12" className="mt-2">
                        <Alert color="danger">
                            {errorMessage}
                        </Alert>
                    </Col>
                )}
                <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                    <tr>
                        <th scope="col">ID Kredit</th>
                        <th scope="col">Kredit</th>
                        <th scope="col">Total Pinjaman</th>
                        <th scope="col">Cicilan per Bulan</th>
                        <th scope="col">Tenor Pinjaman</th>
                        <th scope="col">Tenor Pinjaman Berjalan</th>
                        <th scope="col">NIK</th>
                        <th scope="col">Nama</th>
                        <th scope="col">Status</th>
                        <th scope="col" />
                    </tr>
                    </thead>
                    <tbody>
                    {creditApprovals.length > 0 ? (
                        creditApprovals.map((creditApproval) => (
                            <tr key={creditApproval.kredit_id}>
                                <th scope="row"> {creditApproval.kredit_id} </th>
                                <td> {creditApproval.kredit_name} </td>
                                <td> <NumberFormat
                                    value={creditApproval.amount}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'Rp.'} suffix={',00'} /> </td>
                                <td> {creditApproval.cicilan} </td>
                                <td> {creditApproval.total_installment} </td>
                                <td> {creditApproval.current_installment} </td>
                                <td> {creditApproval.nik} </td>
                                <td> {creditApproval.nama} </td>
                                <td>
                                    <Badge
                                        color={creditApproval.StatusString === 'new' ? "info" : (creditApproval.StatusString === 'rejected' ? "danger" : "success")}>
                                        {creditApproval.StatusString}
                                    </Badge>
                                </td>
                                <td>
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => this.toggleModals("notificationModal", creditApproval)}
                                        size="sm">
                                        Setujui/Tolak</Button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="10" className="text-center">
                                Data tidak ditemukan
                            </td>
                        </tr>
                    )}
                    </tbody>
                </Table>

                <Modal
                    className="modal-dialog-centered"
                    size="md"
                    isOpen={notificationModal}
                    toggle={() => this.toggleModals("notificationModal")}
                >
                    <div className="modal-body p-0">
                        <Card className="bg-secondary shadow border-0">
                            <CardHeader className="bg-transparent">
                                <div className="text-muted text-center mt-2 mb-3">
                                    <h3 className="mb-0">Approval Kredit User</h3>
                                </div>
                            </CardHeader>

                            <CardBody className="px-lg-5 py-lg-4">
                                <div className="text-center mb-4">
                                    <p className="text-muted">
                                        Nama kredit **{toBeApproved?.kredit_name}**
                                    </p>
                                    {/* Menampilkan pesan error di dalam modal jika ada */}
                                    {this.state.errorMessage && (
                                        <Alert color="danger" className="mt-3 mb-0">
                                            {this.state.errorMessage}
                                        </Alert>
                                    )}
                                </div>

                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="total_kredit">
                                        Total Kredit
                                    </Label>
                                    <Input
                                        id="total_kredit"
                                        name="total_kredit"
                                        type="number"
                                        min="0"
                                        value={this.state.total_kredit}
                                        onChange={(e) => this.setState({ total_kredit: e.target.value, errorMessage: undefined })}
                                        placeholder="Masukkan total kredit yang disetujui"
                                    />
                                </FormGroup>
                            </CardBody>

                            <div className="px-lg-5 py-3 d-flex justify-content-end">
                                <Button
                                    className="mr-2"
                                    color="secondary"
                                    type="button"
                                    onClick={() => this.toggleModals("notificationModal")}
                                >
                                    Batal
                                </Button>
                                <Button
                                    className="mr-2"
                                    color="danger"
                                    type="button"
                                    disabled={this.state.submitting}
                                    onClick={() => this.handleSubmitApproval("reject")}
                                >
                                    {this.state.submitting && this.state.submittingAction === 'reject' ? (<><i className="fa fa-spinner fa-spin mr-2" />Menyimpan...</>) : "Tolak"}
                                </Button>
                                <Button
                                    color="success"
                                    type="button"
                                    disabled={this.state.submitting}
                                    onClick={() => this.handleSubmitApproval("approve")}
                                >
                                    {this.state.submitting && this.state.submittingAction === 'approve' ? (<><i className="fa fa-spinner fa-spin mr-2" />Menyimpan...</>) : "Setujui"}
                                </Button>
                            </div>
                        </Card>
                    </div>
                </Modal>
            </>
        )
    };
}

export default UserCreditApprovals;
